<div class="admin-container">
    <h2>Iframe</h2>
    <form class="form">
        <div class="input-group">
            <label>Url:</label>
            <input pInputText name="url" [(ngModel)]="sectionData.url">
        </div>
        <div class="input-group">
            <label>Width:</label>
            <input pInputText name="width" [(ngModel)]="sectionData.width">
        </div>
        <div class="input-group">
            <label>Height:</label>
            <input pInputText name="height" [(ngModel)]="sectionData.height">
        </div>
    </form>
</div>